<template>
  <v-app>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular> <span class="ma-3">Lütfen Bekleyiniz...
      </span>
    </v-overlay>
    <v-container fluid fill-height pa-0>
      <v-row no-gutters>
        <!-- Sol taraf: Login Form -->
        <v-col cols="12" md="3" class="d-flex flex-column justify-center align-center px-12 form-section">
          <div> </div>
          <h1 class="text-h4 font-weight-bold mb-8 text-center">Form Yönetim Sistemi</h1>
          <!-- <v-radio-group v-model="user.tip" row>
            <v-radio label="Kullanıcı" value="kullanici"></v-radio>
            <v-radio label="Yönetici" value="admin"></v-radio>
          </v-radio-group> -->
          <v-form ref="loginForm" v-model="valid" lazy-validation class="w-100" max-width="400">
            <v-text-field v-model="user.username" label="E-posta" prepend-icon="mdi-email" :rules="emailRules"
              required></v-text-field>

            <v-text-field v-model="user.password" label="Şifre" prepend-icon="mdi-lock"
              :type="showPassword ? 'text' : 'password'" :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showPassword = !showPassword" :rules="passwordRules" required></v-text-field>

            <v-list-item>
              <v-list-item-content>
                <table>
                  <tr>
                    <td width="50"><span style="margin-bottom: 5px;">Güvenlik Kodu: </span></td>
                    <td style="width: 100px;"><img :src="captchaImage" style="width: 100px; height: 40px;"
                        alt="Captcha" /></td>
                    <td style="width: 35px;"> <v-btn icon class="mx-2" fab dark color="teal"
                        @click="loadCaptcha"><v-icon>mdi-refresh</v-icon></v-btn></td>
                    <td>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="3"><v-text-field :rules="captchaRules" label="Güvenlik Kodu"
                        v-model="userInputCaptha"></v-text-field></td>
                  </tr>
                </table>





              </v-list-item-content>
            </v-list-item>
            <!-- <v-checkbox v-model="rememberMe" label="Beni hatırla"></v-checkbox> -->

            <v-btn color="primary" block class="mt-4" @click="submit" :disabled="!valid">
              Giriş Yap
            </v-btn>
          </v-form>
        </v-col>

        <!-- Sağ taraf: Görsel -->
        <v-col cols="12" md="9" class="pa-0 d-none d-md-flex" style="position: relative; overflow: hidden;">
          <v-img src="../assets/amasya-universitesi-rektorlugunden_m.jpg" height="100vh" width="100%" cover>
            <!-- <div style="background: rgba(0,0,0,0.4); height: 100%; width: 100%;">

              <v-container style="max-height: 90vh; overflow-y: auto;">
                <v-row>
                  <v-col v-for="anket in ankets" :key="anket.formId" cols="12" sm="6" lg="4">
                    <v-card class="mx-auto elevation-10" border rounded="lg">
                      <v-card-item title="Anket Formu">
                        <v-card-title class="text-h6 font-weight-bold primary--text">
                          {{ anket.name }}
                        </v-card-title>
                      </v-card-item>

                      <v-card-text>
                        <div class="d-flex align-center mb-2">
                          <v-icon size="small" color="success" class="me-2">mdi-calendar-play</v-icon>
                          <strong>Başlangıç:</strong> {{ anket.baslamaTarihi }}
                        </div>
                        <div class="d-flex align-center">
                          <v-icon size="small" color="error" class="me-2">mdi-calendar-check</v-icon>
                          <strong>Bitiş:</strong> {{ anket.bitisTarihi }}
                        </div>
                      </v-card-text>

                      <v-divider class="mx-4"></v-divider>

                      <v-card-actions>
                        <v-btn block variant="elevated" color="deep-purple-accent-4" rounded="pill" class="text-none">
                          Başvur
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>

            </div> -->
          </v-img>
        </v-col>
        <!-- <v-col cols="12" md="9" class="image-section d-none d-md-flex" style="position: relative;">
              <v-img src="../assets/amasya-universitesi-rektorlugunden_m.jpg" height="100vh" width="100%" cover></v-img>
          <v-container style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;">
            <v-row>
              <v-col v-for="anket in ankets" v-bind:key="anket.formId">
                             <v-card >
                              <v-card-title>{{ anket.name }} </v-card-title>
               <v-card-text>
              
                BaşlamaTarihi:{{ anket.baslamaTarihi }}
                BitişTarihi:{{ anket.bitisTarihi  }}
               </v-card-text>
                 <v-card-actions>
      <v-btn
        text
        color="deep-purple accent-4"
      >
        Başvur
      </v-btn>
    </v-card-actions>
          </v-card>
              </v-col>
            </v-row>
          </v-container>
       
      

        </v-col> -->
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import LoginService from '@/services/LoginService';
import userStore from '@/plugins/userStore';
import router from '@/router';
import axios from 'axios';
import FormService from '@/services/FormService';
export default {
  name: 'LoginNoCard',
  data() {
    return {
      captchaImage: null,
      userInputCaptha: null,
      overlay: false,
 
      user: { username: process.env.VUE_APP_USERNAME, password: process.env.VUE_APP_USERPASSWORD, tip: "admin" },
      ankets: [],
      email: '',
      password: '',
      rememberMe: false,
      showPassword: false,
      valid: false,
      emailRules: [
        v => !!v || 'E-posta gerekli',
        v => /.+@.+\..+/.test(v) || 'Geçerli bir e-posta girin',
      ],
      passwordRules: [
        v => !!v || 'Şifre gerekli',
        v => v.length >= 6 || 'Şifre en az 6 karakter olmalı',
      ],
      captchaRules: [
        v => !!v || 'Bu alan noş bırakılamaz.',

      ],
    };
  },
  created() {
    // this.validate()
    this.loadAnkets();
   
  },
    mounted() {
    // Sayfa açıldığında ilk captcha’yı yükle

 this.loadCaptcha();
    // Her 3 dakikada bir yenile
    // setInterval(() => {
    //   this.loadCaptcha();
    // }, 3 * 60 * 1000); // 3 dakika = 180000 ms
  }
,
  methods: {
    loadAnkets() {
      FormService.listCanliAnketFormlari().then((result) => {
        this.ankets = result.data;
      }).catch((err) => {

      });
    },
    loadCaptcha() {


      axios.get(process.env.VUE_APP_APIURL + '/api/captcha/generate', {
        withCredentials: true, // session için gerekli

      }
      ).then((result) => {

        this.captchaImage = result.data.image;
        // this.$toast.success("Başarılı bir şekilde kaydedilmiştir.")
      }).catch((err) => {
        this.$toast.warning(err)
      });





    },
    submit() {
      if (this.$refs.loginForm.validate()) {

        this.overlay = true;
        //this.$route.push("formlar");
        LoginService.login(this.user, this.userInputCaptha).then((result) => {
          this.overlay = false;
          console.log("Lopgin Catchxxxx", result);
          router.push(result.data.defaultMenu);

        }).catch((err) => {
          this.overlay = false;
          console.log("Lopgin Catch");
          if (err && err.response) {
            this.$toast.warning(err.response.data)
          }
          else {
            this.$toast.warning("Sunucu ile bağlantı sorunu bulunmaktadır.Lütfen tekrar deneyiniz.")
          }

        });


      }
    },
  },
};
</script>

<style scoped>
.form-section {
  background-color: #f9f9f9;
  height: 100vh;
}

.image-section {
  height: 100vh;
}
</style>
